import css from "styled-jsx/css";
import colors from "/styles/colors";
import { MOBILE_QUERY_MAX_WIDTH, MAX_DESKTOP_CONTENT_WIDTH, FOLD_TEST_MAX_WIDTH } from "constants/vp-sizes";

export const componentStyles = css`
  .quote-component {
    .quote-component-inner {
      max-width: 900px;
      display: flex;
      padding: 0 20px;

      .person-image-section {
        flex-basis: 70px;
        margin-right: 32px;
        position: relative;
        display: flex;
        align-items: center;

        :global(.person-image) {
          width: 70px;
          height: 70px;
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
          border-radius: 50%;
          box-shadow: 0 2px 16px rgba(0, 0, 0, 0.2);
        }
      }

      .person-text-setcion {
        width: 80%;

        .title {
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: 16px;
        }

        .person-quote {
          margin-bottom: 16px;
          font-size: 1.125rem;
          line-height: 26px;
        }

        .person-title {
          font-size: 0.875rem;
          color: #a1a1a1;
        }
      }

      @media (min-width: ${FOLD_TEST_MAX_WIDTH}) {
        &.above-the-fold {
          max-width: 600px;

          .person-text-setcion {
            .person-quote {
              font-size: 0.875rem;
            }
          }
        }
      }
    }
  }

  @media (max-width: ${MAX_DESKTOP_CONTENT_WIDTH + "px"}) {
    .quote-component {
      .quote-component-inner {
        .person-text-setcion {
          width: 70%;
        }
      }
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .quote-component {
      .quote-component-inner {
        flex-direction: column;
        text-align: center;
        align-items: center;

        .person-text-setcion {
          .person-quote {
            font-size: 1rem;
          }
        }

        .person-image-section {
          margin: 0px auto 8px auto;

          :global(.person-image) {
            width: 80px;
            height: 80px;
            margin-bottom: 16px;
          }
        }
      }
    }
  }
`;
